import AccountView from './components/AccountView';
import './assets/AccountView.css';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import has from 'lodash/has';
import get from 'lodash/get';
import {connect} from 'react-redux';

import {
  loadAgency,
  loadBrandsForAgency,
  loadUsersForAgency,
  loadPaymentMethodsForAgency,
  loadProgramsForAgency,
  loadGiftCards
} from '../../shared/redux/entities/actions';

import {
  loadKPIsForAgencyBrands
} from '../../shared/redux/kpis/actions';

import {
  loadAccountHistory
} from '../../shared/redux/accounting/actions';

function mapStateToProps(state,props){
  const accountId = props.match.params.accountId;
  return {
    accountId:accountId,
    needsLoading:!has(state,['entities','agencies',accountId,'name']),
    name:get(state,['entities','agencies',accountId,'name'])
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadAgency,
    loadBrandsForAgency,
    loadUsersForAgency,
    loadKPIsForAgencyBrands,
    loadPaymentMethodsForAgency,
    loadAccountHistory,
    loadProgramsForAgency,
    loadGiftCards
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AccountView));



// WEBPACK FOOTER //
// ./src/routes/AccountView/index.js